import AbstractListResource from "./abstract/abstract-list-resource"
import defines from "dpsdk/defines"
const {
    Resource,
    DeviceVerificationFilter,
    DeviceWorkStatusFilter,
    DeviceEnabledType
} = defines
import Device from './items/device'
import resourceCollection from './abstract/resource-collection'
import {clearZoneImageCache} from '../pages/devices/zoneImageCache'
import {loadMapDevices, mergeMapDevices} from './device-map-markers'

class Devices extends AbstractListResource {
    constructor() {
        super(Resource.DEVICES, Device)
        super.setCallbacks({
            read: (id, params) => this.api().resourceRead(Resource.DEVICES, id, params),
            get: (params) => this.api().resourceGet(Resource.DEVICES, params),
            update: (id, params) => this.api().resourceUpdate(Resource.DEVICES, id, params),
            create: (params) => this.api().resourceCreate(Resource.DEVICES, params),
            delete: (id) => this.api().resourceDelete(Resource.DEVICES, id),
            upload: (params) => this.api().resourceUpload(Resource.DEVICES, params)
        })
    }

    violationsForDropDown(t, empty) {
        const result = []
        if (empty) {
            result.push({
                label: empty,
                value: null
            })
        }

        return result
    }

    enabledForDropDown(t) {
        return [
            {
                label: t('devices.asDefinedInDetectionProfile'),
                value: DeviceEnabledType.PROFILE
            },
            {
                label: t('devices.disabled'),
                value: DeviceEnabledType.DISABLED
            },
            {
                label: t('devices.enabled'),
                value: DeviceEnabledType.ENABLED
            },
            {
                label: t('devices.maintenance'),
                value: DeviceEnabledType.MAINTENANCE
            }
        ]
    }

    verificationsForDropDown(t, empty) {
        const result = []
        if (empty) {
            result.push({
                label: empty,
                value: null
            })
        }
        result.push(
            {
                label: t('devices.verificationNone'),
                value: DeviceVerificationFilter.NONE
            },
            {
                label: t('devices.verificationHas'),
                value: DeviceVerificationFilter.HAS
            }
        )

        return result
    }

    checkDurationForDropDown(t) {
        const result = []
        for (let i = 1; i <= 5; i++) {
            result.push({
                value: i,
                label: `${i * 12} ${t('devices.months')}`
            })
        }
        return result
    }


    workingStatusForDropDown(t, empty) {
        const result = []
        if (empty) {
            result.push({
                label: empty,
                value: null
            })
        }

        result.push(
            {
                label: t('devices.notWorking'),
                value: DeviceWorkStatusFilter.NOT_WORKING
            },
            {
                label: t('devices.working'),
                value: DeviceWorkStatusFilter.WORKING
            },
            {
                label: t('devices.errors'),
                value: DeviceWorkStatusFilter.ERRORS
            },
            {
                label: t('devices.noReportsMoreThan1hour'),
                value: DeviceWorkStatusFilter.NO_REPORTS_1HOUR_OR_MORE
            },
            {
                label: t('devices.noReportsMoreThan24hours'),
                value: DeviceWorkStatusFilter.NO_REPORTS_24HOUR_OR_MORE
            }
        )

        return result
    }

    export(language, filters) {
        const keys = Object.keys(filters)
        keys.forEach((key) => {
            if (undefined === filters[key]) {
                delete filters[key]
            }
        })

        return this.api().resourceExport(Resource.DEVICES, {language, ...filters})
    }

    async markers(filters) {
        const [markers, devices] = await Promise.all([
            this.api().resourceGet(`${Resource.DEVICES.toLowerCase()}/map/markers`, filters),
            loadMapDevices(params => this.api().resourceGet(Resource.DEVICES, params), filters)
        ])
        return mergeMapDevices(markers, devices)
    }

    deleted(id, remoteUpdate = false) {
        return dispatch => {
            const deviceIds = Array.isArray(id) ? id : [id]
            this.invalidatePendingLoad()
            deviceIds.forEach(deviceId => {
                const cached = this.singleItems[deviceId]
                const listed = this.ids[deviceId]
                ;[cached, listed].forEach(device => {
                    if (device) {
                        device.zones = []
                        device.zoneInstances = []
                    }
                })
                this.clearSingleData(deviceId)
                Object.keys(this.singleItems).forEach(key => {
                    const device = this.singleItems[key]
                    if (device && String(device.id) === String(deviceId)) {
                        device.zones = []
                        device.zoneInstances = []
                        this.clearSingleData(key)
                    }
                })
                clearZoneImageCache(deviceId)
            })
            const zones = resourceCollection.getResource(Resource.ZONES)
            if (zones) dispatch(zones.clearForDevices(deviceIds))
            // Match string and numeric IDs, including deletion notifications.
            const normalizedIds = deviceIds.map(deviceId => {
                const item = (this.items || []).find(device => String(device.id) === String(deviceId))
                return item ? item.id : deviceId
            })
            dispatch(super.deleted(Array.isArray(id) ? normalizedIds : normalizedIds[0], remoteUpdate))
            deviceIds.forEach(deviceId => { delete this.ids[deviceId] })
        }
    }

    marker(id) {
        return this.api().resourceGet(`${Resource.DEVICES.toLowerCase()}/map/marker/${id}`)
    }

    forDropDown(empty) {
        if (!this.isInitialized()) {
            return []
        }

        const result = []
        if (empty) {
            result.push({
                label: empty,
                value: null
            })
        }
        this.getItems().forEach(item => {
            result.push({
                label: `#${item.id} ${item.title}`,
                value: item.id
            })
        })

        return result
    }
}

const dropDownDevices = new Devices()

export {dropDownDevices}
export default new Devices()
